import { handleActions } from "redux-actions";
import {
    SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_COMPLETE,
    SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_REQUEST,
    SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_RESET,
    SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_SET,
} from "constants/action-types";

interface IState {
    error?: boolean;
    errorObject: any;
    isFetching: boolean;
    isUpdating: boolean;
    results: string[];
}

const initialState: IState = {
    error: undefined,
    errorObject: undefined,
    isFetching: false,
    isUpdating: false,
    results: [],
};

export const accountCarrierServiceWarehouseService = handleActions(
    {
        [SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_REQUEST]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
                errorObject: undefined,
            };
        },
        [SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_COMPLETE]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isFetching: false,
                    isUpdating: false,
                };
            }

            return {
                ...state,
                isFetching: false,
                isUpdating: false,
                errorObject: undefined,
                results: state.results.length ? state.results.concat(payload) : payload,
            };
        },
        [SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_SET]: (state: IState): IState => {
            return {
                ...state,
                isUpdating: true,
            };
        },
        [SHIPPING_ACCOUNT_CARRIER_WAREHOUSE_SERVICES_RESET]: (): IState => {
            return initialState;
        },
    },
    initialState
);
